import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeNumber,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalNumber,
  nullSafeOptionalString,
  nullSafeString,
} from '../shared/schema'
import { ExhibitGridDisplayMode, SlideType } from './types'

// this is the dart Slide definition
// required String slideName, default: ''
// required SlideType slideType, default: SlideType.none
// required String slideDescription,
// required int slideDuration,
// String? slideImageURL,
// int? slideOrder,
// String? slideStorageURL,
// int? slideVideoDuration,
// String? slideVideoError,
// String? slideVideoURL,
// int? updatedAt,
export const schema = z.object({
  slideName: nullSafeString(''),
  slideType: z.preprocess((val) => {
    return val ?? SlideType.image
  }, z.nativeEnum(SlideType)),
  // this is a virtual field, resolved from interactive elements
  // it has no corresponding field in the firestore document
  // slideHeading: nullSafeOptionalString(),
  slideDescription: z.string(),
  slideDuration: z.number(),
  slideImageURL: nullSafeOptionalString(),
  slideImageAltText: nullSafeOptionalString(),
  slideOrder: nullSafeNumber(999),
  slideStorageStreamingURL: nullSafeOptionalString(),
  slideStorageURL: nullSafeOptionalString(),
  slideVideoDuration: nullSafeOptionalNumber(),
  slideVideoError: nullSafeOptionalString(),
  slideVideoStreamingURL: nullSafeOptionalString(),
  slideVideoURL: nullSafeOptionalString(),
  slideVideoYouTubeURL: nullSafeOptionalString(),
  slideIframeURL: nullSafeOptionalString(),
  slideMediaFilename: nullSafeOptionalString(),
  slideGoogleTemplateURL: nullSafeOptionalString(),
  slideInputQuestionIds: z.array(z.string()).optional(),
  isSkippable: z.boolean().default(false),
  mediaId: nullSafeOptionalString(),

  // BL-4216 — Dynamic Intro Video slide: one Media id per variant. The
  // runtime picks slideSoloMediaId when the room was launched as solo
  // (RoomState.launchedAsSolo), otherwise slideGroupMediaId.
  slideGroupMediaId: nullSafeOptionalString(),
  slideSoloMediaId: nullSafeOptionalString(),

  // animated cards
  slideAnimatedCardsTitle: nullSafeOptionalString(),
  slideAnimatedCardsDescription: nullSafeOptionalString(),
  slideAnimatedCardsItems: z
    .array(
      z.object({
        title: z.string(),
        description: z.string().optional(),
      })
    )
    .optional(),
  slideAnimatedCardsSubtext: nullSafeOptionalString(),

  slideExhibitGridDisplayMode: z.nativeEnum(ExhibitGridDisplayMode).optional(),
  schema: nullSafeOptionalString(),
  // learning objectives
  slideLearningObjectivesHeading: nullSafeOptionalString(),
  slideLearningObjectivesIntro: nullSafeOptionalString(),
  slideLearningObjectivesBullets: z.array(z.string()).optional(),

  // dates
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  slideMarkdown: nullSafeOptionalString(),
})

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    slideName: '',
    slideType: SlideType.image,
    slideDescription: '',
    slideDuration: 999,
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export type FirestoreSlide = z.infer<typeof schema>
